import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import ProductLine from '@afosto/app-components-react/ProductLine';
import QuantityBox from '@afosto/app-components-react/QuantityBox';
import translations from './translations';

const AttachRow = ({ available, onChange, onMinus, onPlus, requested, row, quantity }) => {
  const intl = useIntl();
  let color = 'primary';

  if (requested === quantity) {
    color = 'success';
  }

  if (requested > quantity && quantity > 0) {
    color = 'warning';
  }

  return (
    <Grid item xs={12}>
      <Card>
        <Box display="flex" flexWrap="wrap" width="100%" p={2}>
          <Box flex={1}>
            <ProductLine item={row} />
          </Box>
          <Box display="flex">
            <QuantityBox
              quantity={requested ?? 0}
              label={intl.formatMessage(translations.properties.expected)}
            />
            <Box ml={2}>
              <QuantityBox
                label={intl.formatMessage(translations.properties.quantity)}
                quantity={quantity ?? 0}
                color={color}
                onChange={onChange}
                onMinus={onMinus}
                onPlus={onPlus}
                allowEdit
              />
            </Box>
            <Box ml={2}>
              <QuantityBox
                quantity={available ?? 0}
                label={intl.formatMessage(translations.properties.available)}
                color="none"
              />
            </Box>
          </Box>
        </Box>
      </Card>
    </Grid>
  );
};

AttachRow.propTypes = {
  available: PropTypes.number,
  onChange: PropTypes.func,
  onMinus: PropTypes.func,
  onPlus: PropTypes.func,
  requested: PropTypes.number,
  row: PropTypes.object,
  quantity: PropTypes.number,
};

AttachRow.defaultProps = {
  available: 0,
  onChange: undefined,
  onMinus: undefined,
  onPlus: undefined,
  requested: 0,
  row: undefined,
  quantity: 0,
};

export default AttachRow;
